import type {
  BaseField,
  CommonFieldProps,
  FieldComponentType,
} from "@bleu.builders/ui";
import { buildForm as bleuUiBuildForm } from "@bleu.builders/ui";
import { ImageMultiSelectCheckboxesField } from "@perk/core/components/image-multi-select-checkboxes-field";
import { ImageRadioGroupField } from "@perk/core/components/image-radio-group-field";
import { ListField } from "@perk/core/components/list-field";
import { RadioGroupField } from "@perk/core/components/styled-radio-group-field";
import { DatePickerInput as YearCalendarField } from "@perk/core/components/year-calendar-field";
import { MultiSelectCheckboxField } from "@perk/core/components/styled_multi_select_checkbox";
import { PhoneField } from "../components/phone-field";

type CustomFieldTypes = {
  image_radio: typeof ImageRadioGroupField;
  image_checkbox: typeof ImageMultiSelectCheckboxesField;
  styled_radio_group: typeof RadioGroupField;
  styled_multi_select_checkbox: typeof MultiSelectCheckboxField;
  year_calendar_time: typeof YearCalendarField;
  year_calendar: typeof YearCalendarField;
  phone: typeof PhoneField;
  list: typeof ListField;
};

const customFields: { [K in keyof CustomFieldTypes]: FieldComponentType } = {
  image_radio: ImageRadioGroupField as FieldComponentType,
  image_checkbox: ImageMultiSelectCheckboxesField as FieldComponentType,
  styled_radio_group: RadioGroupField as FieldComponentType,
  styled_multi_select_checkbox: MultiSelectCheckboxField as FieldComponentType,
  year_calendar_time: YearCalendarField as FieldComponentType,
  year_calendar: YearCalendarField as FieldComponentType,
  phone: PhoneField as FieldComponentType,
  list: ListField as FieldComponentType,
};

export const buildForm = (
  fields: CommonFieldProps<BaseField>["field"][],
  form: CommonFieldProps<BaseField>["form"],
  index = 0
) => {
  return bleuUiBuildForm(fields, form, index, customFields);
};
